import { FileFormat } from '../../../shared/types/resultsDownload';

export const fileFormatsResultsDownload = [
  FileFormat.tsv,
  FileFormat.excel,
  FileFormat.list,
  FileFormat.json,
];

export const fileFormatEntryDownload = [
  FileFormat.rdfXml,
  FileFormat.tsv,
  FileFormat.excel,
  FileFormat.json,
];
